export default "__VITE_ASSET__DIPUuK$V__"